import React, { useState, useEffect, useRef, forwardRef } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Popconfirm,
  message,
  Modal,
  Card,
  Tooltip,
  DatePicker,
  Select,
  Rate,
  Badge,
  Tag,
} from "antd";

import { API_LIST_ORDER, API_DELETE_ORDER } from "api/order-management";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { debounce } from "lodash";

import { API_GET_TRANSECTION_OF_DRIVER } from "api/laundry-management";

const { Column } = Table;
const { TextArea } = Input;
const { RangePicker } = DatePicker;
const { Option } = Select;
const TransectionsDriver = ({ id }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 8 });
  const [searchName, setSearchName] = useState("");
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [status, setStatus] = useState(null);
  const [orderType, setOrderType] = useState(null);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const options = [
    t("order_placed"),
    t("order_delivered_to_store_before_service"),
    t("order_delivered_to_laundry_before_service"),
    t("order_service_completed"),
    t("order_delivered_to_store_after_service"),
    t("order_delivered_successfully"),
  ];
  const formattedOptions = options?.map((status) => ({
    value: status,
    label: status
      ?.replace(/_/g, " ")
      ?.replace(/\b\w/g, (char) => char.toUpperCase()),
  }));
  // Fetch data from API
  const fetchData = async () => {
    try {
      setLoading(true);
      const params = {
        page: pagination.current,
        limit: pagination.pageSize,
        order_user_name: searchName,
        order_status: status,
        order_type: orderType,
        minDate: startDate ? startDate.unix() : undefined,
        maxDate: endDate ? endDate.unix() : undefined,
      };
      const newData = await API_GET_TRANSECTION_OF_DRIVER(params, id);
      setData(newData?.transactions); // Assuming newData structure
      setLoading(false);
      setPagination({ ...pagination, total: newData.total_items });
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [
    pagination.current,
    pagination.pageSize,
    searchName,
    startDate,
    endDate,
    orderType,
    status,
  ]);
  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleSearch = (value) => {
    setSearchName(value);
  };
  const handleEdit = (record) => {
    setSelectedStore(record);
    setEditModalVisible(true);
    navigate(`/admin/order-management/edit/${record._id}`, {
      state: { data: record },
    });
  };
  const handleView = (record) => {
    setSelectedStore(record);
    setViewModalVisible(true);
    navigate(`/admin/order-management/${record._id}`, {
      state: { data: record },
    });
  };
  const handleDelete = async (id) => {
    try {
      const response = await API_DELETE_ORDER(id);
      message.success(response.message);
      fetchData();
    } catch (error) {
      console.error("Error deleting order:", error);
      message.error("Failed to delete order");
    }
  };
  const handleEditModalOk = () => {
    console.log("Editing order:", selectedStore);
    setEditModalVisible(false);
    fetchData();
  };

  const handleViewModalOk = () => {
    console.log("Viewing order:", selectedStore);
    setViewModalVisible(false);
  };

  const handleModalCancel = () => {
    setEditModalVisible(false);
    setViewModalVisible(false);
  };

  const getRowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };
  useEffect(() => {
    if (orderType || status) {
      const debounceResetPagination = debounce(() => {
        setPagination((prev) => ({ ...prev, current: 1 }));
      }, 300); // Wait 300ms before resetting
      debounceResetPagination();
      return () => debounceResetPagination.cancel();
    }
  }, [orderType, status]);
  return (
    <div>
      <div className="mb-4 flex flex-wrap justify-between gap-4">


        {/* <div className="w-full flex-grow sm:w-auto">
          <RangePicker
            onChange={(dates) => {
              setStartDate(dates ? dates[0] : null);
              setEndDate(dates ? dates[1] : null);
            }}
            className="w-full"
          />
        </div> */}

        <div className="w-full flex-grow sm:w-auto">
          <Select
            className="w-full border-none"
            onChange={(value) => setStatus(value)}
            value={status}
            placeholder={t("please pick order status")}
            options={formattedOptions}
            allowClear
          />
        </div>

        <div className="w-full flex-grow sm:w-auto">
          <Select
            placeholder={t("please pick order type")}
            value={orderType}
            onChange={(value) => setOrderType(value)}
            className="w-full"
            allowClear
          >
            <Option value="normal">{t("Normal")}</Option>
            <Option value="express">{t("Express")}</Option>
            <Option value="box">{t("Laundry Box")}</Option>
          </Select>
        </div>
        <div className="w-full flex-grow sm:w-auto">
        </div>
        <div className="w-full flex-grow sm:w-auto">
        </div>
        {/* <div className="flex w-full flex-grow justify-end sm:w-auto">
          <Link
            to={"/admin/order-management/create-order"}
            className="linear p-[4px 11px] flex w-full max-w-[9rem] cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-2 text-center text-base font-medium text-white transition duration-200 hover:bg-white hover:text-brand-500 dark:bg-brand-400 dark:text-white  dark:active:bg-brand-200"
          >
            + {t("Create order")}
          </Link>
        </div> */}
      </div>

      {/* </div> */}
      <Table
        dataSource={data}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        rowKey={(record) => record._id}
        rowClassName={getRowClassName}
        scroll={{ x: true }}
      >
        {/* Columns definition */}
        <Column
          title={t("Order id")}
          dataIndex="order_id"
          key="order_id"
          width="5rem"
          render={(text, record) => (
            <span>{record?.order_details?.order_id}</span>
          )}
        />

        <Column
          title={t("order Status")}
          dataIndex="order_status"
          key="order_status"
          width="9rem"
          render={(text, record) => (
            <span>
              {record?.order_details?.order_status?.replace(/_/g, " ")}
            </span>
          )}
        />
        <Column
          title={t("Order Type")}
          key="order_type "
          dataIndex="order_type"
          width="9rem"
          render={(text, record) => (
            <span>{record?.order_details?.order_type}</span>
          )}
          //   render={(text, record) => <span>{record?.email}</span>}
        />
        {/* <Column title={t("Role")} dataIndex="role" key="role" /> */}
        <Column
          title={t("Transaction Type")}
          dataIndex="transaction_type"
          key="transaction_type"
          width="9rem"
          //   render={(text, record) => <span>{record?.phone_no}</span>}
        />

        <Column
          title={t("Amount")}
          dataIndex="amount"
          key="amount"
          width="9rem"
          render={(text, record) => <span>{Number(record?.amount)?.toFixed(2)} {t("SAR")}</span>}
        />
        <Column
          title={t("Remaining Balance")}
          dataIndex="remaining_balance"
          key="remaining_balance"
          width="9rem"
          render={(text, record) => (
            <span>{Number(record?.remaining_balance)?.toFixed(2)} {t("SAR")}</span>
          )}

          // render={(text, record) => (
          //   record?.status ==
          // )}
        />
      </Table>

      <Modal
        open={isModalOpen}
        // closable={true}
        closeIcon={false}
        onCancel={() => setIsModalOpen(false)}
        style={{ width: "674px", padding: "0px !important" }}
        className="w-[674px]"
      >
        <div className="flex w-[674px] justify-between gap-[28px] border-y-[1px] py-[18px]">
          <div
            style={{
              width: "299px",
              padding: "14px",
              boxShadow: "0px 0px 10px rgba(90, 176, 255, 0.25)",
            }}
            className="flex flex-col gap-[20px] shadow-xl shadow-[#5AB0FF40]"
          >
            <div className="flex flex-row justify-between gap-[58px]">
              <div className="flex flex-row gap-[12px]">
                <div className="h-[58.02px] w-[55px] rounded-[10px] bg-[#172E550D]"></div>
                <div className="flex flex-col gap-[15px]">
                  <p className="">{t("T-Shirt")}</p>
                  <div></div>
                </div>
              </div>
            </div>
            <div></div>
          </div>
          <div
            style={{
              width: "299px",
              padding: "14px",
              boxShadow: "0px 0px 10px rgba(90, 176, 255, 0.25)",
            }}
            className="shadow-xl "
          >
            {t("next")}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default TransectionsDriver;
